import * as DirectoryApi from '@bmai/directory-api-client';
import { ApiClientFactory } from './ApiClientFactory';

const configuration = new DirectoryApi.Configuration(ApiClientFactory.createConfig('/_directory'));

export const directoryClient = ApiClientFactory.instantiateApis(DirectoryApi, configuration);
